// ===============================
// SessionStorage helpers
// ===============================
const STORAGE_KEY = 'context'

const defaultContextState = {
  brand_id: null,
  brand_name: '',
  project_id: null,
  project_name: '',
  simulation_id: null,
  simulation_name: '',
}

const loadContextFromStorage = () => {
  try {
    const data = sessionStorage.getItem(STORAGE_KEY)
    if (!data) return null
    const parsed = JSON.parse(data)
    return {
      ...parsed,
    }
  } catch (error) {
    console.error('Failed to load context from storage', error)
    return null
  }
}

const saveContextToStorage = (context) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(context))
  } catch (error) {
    console.error('Failed to save context to storage', error)
  }
}

const removeContextFromStorage = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch (error) {
    console.error('Failed to remove context from storage', error)
  }
}

// ===============================
// Initial State (rehydrated)
// ===============================
const initialState = loadContextFromStorage() || { ...defaultContextState }

const SET_CONTEXT = 'SET_CONTEXT'
const MERGE_CONTEXT = 'MERGE_CONTEXT'
const CLEAR_CONTEXT = 'CLEAR_CONTEXT'

const contextReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CONTEXT: {
      const contextData = {
        brand_id: action.payload.brand_id,
        brand_name: action.payload.brand_name,
        project_id: action.payload.project_id,
        project_name: action.payload.project_name,
        simulation_id: action.payload.simulation_id,
        simulation_name: action.payload.simulation_name,
      }
      const nextState = {
        ...state,
        ...contextData,
      }
      saveContextToStorage(nextState)
      return nextState
    }
    case MERGE_CONTEXT: {
      const nextState = { ...state }
      if (action.payload && typeof action.payload === 'object') {
        for (const [key, value] of Object.entries(action.payload)) {
          if (value !== undefined) {
            nextState[key] = value
          }
        }
      }
      saveContextToStorage(nextState)
      return nextState
    }
    case CLEAR_CONTEXT:
      removeContextFromStorage()
      return { ...defaultContextState }
    default:
      return state
  }
}

export const setContext = ({
  brand_id = null,
  brand_name = '',
  project_id = null,
  project_name = '',
  simulation_id = null,
  simulation_name = '',
}) => ({
  type: SET_CONTEXT,
  payload: { brand_id, brand_name, project_id, project_name, simulation_id, simulation_name },
})

export const clearContext = () => ({
  type: CLEAR_CONTEXT,
})

/** Shallow-merge context fields. Use `undefined` to skip a key; `null` clears a field. */
export const mergeContext = (partial) => ({
  type: MERGE_CONTEXT,
  payload: partial,
})

export default contextReducer
